// extracted by mini-css-extract-plugin
module.exports = {"shareButtonWrapper":"QO080","shareButton":"tsJJj","shareIcon":"Ukla1"};